/**
 * Return a value from the provided array using a value accessor method
 */
export function maxBy<T>(arr: T[], accessor: (val: T) => number): T | null {
  return arr.reduce((maxVal, currentVal) => {
    return accessor(currentVal) > accessor(maxVal) ? currentVal : maxVal
  }, arr[0])
}
